import React from 'react';
import IDHelpers from '../../../../../../core/helpers/IDHelper';
import { EventCardsProps } from './events.interface';
import { getSortedEventsNew } from '../EventUtils';
import { CardButtonEvent } from '../../card/CardButtonEvent';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const EventCards = ({
  events,
  selectEvent,
  isSubscribed = false
}: EventCardsProps) => {
  const eventsToSort = [...events].filter(
    (event) =>
      (isSubscribed && event.isSubscribed) ||
      (!isSubscribed && !event.isSubscribed)
  );

  const SortedEvents = (preSortEvents: any[]) => {
    const compareDates = (a: any, b: any) => {
      if (a.startDate < b.startDate) return -1;
      if (b.startDate > a.startDate) return 1;
      return 0;
    };

    return [...preSortEvents].sort(compareDates);
  };

  const PreSortedEvents = getSortedEventsNew(eventsToSort);
  const sortedEvents = SortedEvents(PreSortedEvents);
  return (
    <div className="gridCardEvent" data-testid="cmp-event-card-view2">
      {events &&
        sortedEvents.map((event: any) => (
          <CardButtonEvent
            key={IDHelpers.generateID()}
            event={event}
            selectEvent={() => {
              GoogleAnalytics.writeLog(
                'portal-services-cardEventRegistered',
                'services'
              );
              selectEvent(event.idEvent, 'Inscritos');
            }}
          />
        ))}
    </div>
  );
};

export default EventCards;
